import { useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  breadcrumbs?: BreadcrumbItem[];
  schema?: Record<string, unknown>;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', breadcrumbs, schema }: SEOHeadProps) {
  const location = useLocation();
  const baseUrl = 'https://www.jiuyaomanhua.com';
  const fullUrl = canonicalUrl || `${baseUrl}${location.pathname}`;

  const fullTitle = title.includes('九妖漫画网') ? title : `${title} - 九妖漫画网`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="九妖漫画网" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      {breadcrumbs && breadcrumbs.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbs.map((item, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              name: item.label,
              item: item.href ? `${baseUrl}${item.href}` : undefined,
            })),
          })}
        </script>
      )}

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </>
  );
}

export function OrganizationSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '九妖漫画网',
    url: 'https://www.jiuyaomanhua.com',
    description: '九妖漫画网 - 免费在线看漫画全集，高清无删减资源',
    email: 'contact@jiuyaomanhua.com',
    telephone: '400-888-9999',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '北京市',
      addressCountry: 'CN',
      streetAddress: '朝阳区建国路88号九妖大厦',
    },
    sameAs: [
      'https://weibo.com/jiuyaomanhua',
      'https://www.jiuyaomanhua.com',
    ],
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
}

export function WebsiteSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '九妖漫画网',
    url: 'https://www.jiuyaomanhua.com',
    description: '九妖漫画网官网网页版登录入口，免费在线看漫画全集，高清无删减资源',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.jiuyaomanhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
}